var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomark512Maskable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5267EA",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.074 245.632c40.671 0 73.641-32.971 73.641-73.642s-32.97-73.641-73.641-73.641c-40.671 0-73.641 32.97-73.641 73.641 0 40.671 32.97 73.642 73.641 73.642z",
    fill: "#171D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.353 98H96v147.353h147.353V98z",
    fill: "#EE9AB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.076 276.794l38.427 68.052 38.498 68.052H262.15l38.498-68.052 38.428-68.052z",
    fill: "#FFC550"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.641 413.945c40.671 0 73.642-32.971 73.642-73.642s-32.971-73.641-73.642-73.641S96 299.632 96 340.303c0 40.671 32.97 73.642 73.641 73.642z",
    fill: "#FAFAEE"
  })));
}
export default SvgLogomark512Maskable;